
import makerjs from "makerjs";
function B39(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    B = Param[0].param,L = Param[1].param,R = Param[2].param,T = Param[3].param, 
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       b = B * 1 * myZoom,
       l = L * 1 * myZoom,
       t = T * 1 * myZoom,
       r = R * 1 * myZoom,
      //  s1 = S1 * 1 * myZoom,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       
       x0 = 0, x1 = 0, x2 =(b-t)/2 ,x3 =b-(b-t)/2 ,x4 =b ,x5 =b, 
       y0 = 0, y1 =r,y2 =l, y3 =l,y4 =r,y5 =0,glassH =l, glassW = b,h=l,w=b;

   if (b !== 0) {
       var TxtB ="B="+ B;
   }  if (l !== 0) {
    var TxtL = "L="+L;
  } if (t !== 0) {
    var TxtT = "T="+T;
  }  if (r !== 0) {
    var TxtR = "R="+R;
  } 



   var drawAbnormalShapeB39 = {
       paths: {
        "LeftLine1": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "LeftLine2": new makerjs.paths.Line([x1, y1], [x2,y2]),
        "TopLine":new makerjs.paths.Line([x2,y2], [x3,y3]), 
        "RightLine1":new makerjs.paths.Line([x3,y3], [x4,y4]), 
        "RightLine2":new makerjs.paths.Line([x4,y4], [x5,y5]),
        "BottomLine": new makerjs.paths.Line([x5,y5], [x0, y0]),
       }
   };
   var drawAbnormalShapeB39MarkL = {
       paths: {
        "RightLine": new makerjs.paths.Line([x0- markShift, y0], [x1- markShift, y2]),
        "RightShortUpline": new makerjs.paths.Line([x1, y2], [x1- 2 * markShift, y2]),
        "RightShortDnline": new makerjs.paths.Line([x0, y0], [x0- 2 * markShift, y0]),
       }
   };
   var drawAbnormalShapeB39MarkR = {
       paths: {
        "RightLine": new makerjs.paths.Line([x4+ markShift, y4], [x4+ markShift, y5]),
        "RightShortUpline": new makerjs.paths.Line([x4, y4], [x4+ 2 * markShift, y4]),
        "RightShortDnline": new makerjs.paths.Line([x4, y5], [x4+ 2 * markShift, y5]),
       }
   };
   var drawAbnormalShapeB39MarkB = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x0, y0- markShift], [x5, y5- markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x5, y5], [x5, y5 - 2 * markShift]),
       }
  
   };
   var drawAbnormalShapeB39MarkT = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x2, y2+ markShift], [x3, y3+ markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x2, y2], [x2, y2 + 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x3, y3], [x3, y3 + 2 * markShift]),
       }
  
   };
   makerjs.model.addCaption(drawAbnormalShapeB39MarkB, TxtB, [x0, y0 - 2 * markShift], [x5, y5 - 2 * markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB39MarkT, TxtT, [x2, y2+ 2*markShift], [x3, y3+ 2*markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB39MarkL, TxtL, [x1-2*markShift, y0], [x1-2*markShift, y2]);//宽度文字
   makerjs.model.addCaption(drawAbnormalShapeB39MarkR, TxtR, [x4+ 3*markShift, y4], [x4+ 3*markShift, y5]);//宽度文字
  //  makerjs.model.addCaption(drawAbnormalShapeB39MarkS1, TxtS1, [x0, y0- 6*markShift], [x5, y5- 6*markShift]);//宽度文字
   
  plate={
    models: {
      drawAbnormalShapeB39: drawAbnormalShapeB39,
      }
    };
    markers={
      models: {
        drawAbnormalShapeB39: drawAbnormalShapeB39,
        drawAbnormalShapeB39MarkL: drawAbnormalShapeB39MarkL,
        drawAbnormalShapeB39MarkT: drawAbnormalShapeB39MarkT,
        drawAbnormalShapeB39MarkB:drawAbnormalShapeB39MarkB,
        drawAbnormalShapeB39MarkR:drawAbnormalShapeB39MarkR,
        // drawAbnormalShapeB39MarkS1:drawAbnormalShapeB39MarkS1,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default B39;